import { Flex, Grid, Text } from '@chakra-ui/react'
import { UseConsentFormsStatus } from '@hb/react'
import { makePluralIfNecessary } from '@hb/shared'
import { useMemo } from 'react'
import { useProfile } from '../../../contexts/user/ProfileContext'
import { useSignOnComplete } from '../../../hooks/backend/assessments/useSignOnComplete'
import { ScheduledCallButton } from './ScheduledCallButton'
import { SignOnStatusItem } from './SignOnStatusItem'

const ConsentFormsStatusItem = ({ status }: { status: UseConsentFormsStatus }) => {
  const { numConsentForms, complete, numSignedConsentForms } = status
  const text = useMemo(() => {
    if (numConsentForms === 0) return 'No Consent Forms'
    return `${numSignedConsentForms}/${numConsentForms} ${makePluralIfNecessary(
      'Consent Form',
      numConsentForms,
    )}`
  }, [numConsentForms, numSignedConsentForms])
  return <SignOnStatusItem label={text} complete={numConsentForms > 0 && complete} />
}

export const SignOnStatus = ({ width }: { width: number }) => {
  const {
    user,
    selectedAssessment: { populated: assessment },
  } = useProfile()
  const {
    consentFormsStatus,
    signOnFormComplete,
    insuranceCallInForm,
    insuranceCallInSubmittedOn,
  } = useSignOnComplete(user, assessment)

  // const mobileLayout = useMemo(() => width < 700, [width])
  const numItems = useMemo(() => {
    if (insuranceCallInForm) return 4
    return 3
  }, [insuranceCallInForm])
  const numCols = useMemo(() => {
    if (width < 390) return 1
    if (width < 750) return numItems > 3 ? 2 : 1
    return numItems
  }, [width, numItems])

  return (
    <Flex align="center" gap={1} flexFlow="column" w="100%">
      <Text color="gray.600" fontWeight={600}>
        Sign On Status
      </Text>
      <Grid gap={2} w="100%" templateColumns={`repeat(${numCols}, 1fr)`}>
        <SignOnStatusItem label="Sign-On Form" complete={signOnFormComplete} />
        {insuranceCallInForm ? (
          <SignOnStatusItem label="Insurance Call-In" complete={!!insuranceCallInSubmittedOn} />
        ) : null}
        <ScheduledCallButton />
        <ConsentFormsStatusItem status={consentFormsStatus} />
      </Grid>
    </Flex>
  )
}
